<form [formGroup]="reclaimForm" autocomplete="off" class="form-container">
  <div class="row w-100 m-0 p-0">
    <mat-form-field appearance="outline" class="col-lg-6">
      <mat-label>Seguro relacionado</mat-label>
      <mat-select formControlName="sureId" required style="font-size:16px;" (selectionChange)="changeInsurance()">
        <mat-option [value]="null" *ngIf="!reclaimForm.get('sureId').value">Seleccionar</mat-option>
        <mat-option *ngFor="let item of insurances" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="reclaimForm.get('sureId').hasError('required')">
        El seguro relacionado es <strong>requerido</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-6">
      <mat-label>Tema asociado al inconveniente</mat-label>
      <mat-select formControlName="themeId" required style="font-size:16px;">
        <mat-option [value]="null" *ngIf="!reclaimForm.get('themeId').value">Seleccionar</mat-option>
        <mat-option *ngFor="let item of themes" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="reclaimForm.get('themeId').hasError('required')">
        El tema asociado al inconveniente es <strong>requerido</strong>.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row w-100 m-0 p-0">
    <mat-form-field appearance="outline" class="col-lg-6 m-auto">
      <mat-label>Ingresa el detalle de lo sucedido</mat-label>
      <textarea matInput #sucedido name="sucedido" formControlName="detail" type="text" rows="5" max-rows="6"
        maxlength="300" required></textarea>
      <mat-hint align="end">{{sucedido.value.length}} / 300</mat-hint>
      <mat-error *ngIf="reclaimForm.get('detail').hasError('required')">
        Campo <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="reclaimForm.get('detail').hasError('minlength')">
        El detalle mínimo debe tener <strong>1 carácter</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-6 m-auto">
      <mat-label>¿Qué solicita?</mat-label>
      <textarea matInput #queSolicitas name="queSolicitas" formControlName="request" type="text" rows="5" max-rows="6"
        maxlength="300" required placeholder="Cuéntanos cómo te podemos ayudar"></textarea>
      <mat-hint align="end">{{queSolicitas.value.length}} / 300</mat-hint>
      <mat-error *ngIf="reclaimForm.get('request').hasError('required')">
        Campo requerido
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row w-100 m-0 p-0">
    <mat-form-field class="col-lg-4 pure-material-textfield-outlined" appearance="outline" *ngIf="historySOAT">
      <mat-label>Placa del vehículo</mat-label>
      <input formControlName="licensePlate" matInput maxlength="6" required placeholder="Ingresar Placa del vehículo"
        oninput="this.value=this.value.trim()==''?'':this.value.toUpperCase()" #placaVehiculo>
      <mat-hint align="end">{{placaVehiculo.value.length}} / 6</mat-hint>
      <mat-error *ngIf="reclaimForm.get('licensePlate').hasError('required')">
        La Placa del vehículo es <strong>requerida</strong>.
      </mat-error>
      <mat-error *ngIf="reclaimForm.get('licensePlate').hasError('minlength')">
        La Placa del vehículo debe tener <strong>6 carácteres</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field class="col-lg-4 pure-material-textfield-outlined" appearance="outline">
      <mat-label [ngClass]="{ 'is-invalid-text': submitted && reclaimForm.get('date').errors }">¿Cuándo sucedió?
      </mat-label>
      <input formControlName="date" matInput [max]="min" [matDatepicker]="picker">
      <mat-datepicker-toggle matSuffix [for]="picker">
      </mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="submitted && reclaimForm.get('date').hasError('required')">
        La fecha es requerido
      </mat-error>
    </mat-form-field>
    <mat-form-field class="col-lg-4 pure-material-textfield-outlined timePicker" appearance="outline"
      *ngIf="!historySOAT">
      <mat-label [ngClass]="{ 'is-invalid-text': submitted && reclaimForm.get('time').errors }">Hora y minutos
      </mat-label>
      <input class="timeMinWidth" formControlName="time" matInput type="time" min="09:00" max="18:00">
      <!-- <mat-icon matSuffix class="material-icons-outlined mx-2 my-0">schedule</mat-icon> -->
      <mat-error *ngIf="submitted && reclaimForm.get('time').hasError('required')">
        La hora es requerido
      </mat-error>
      <mat-error *ngIf="submitted && reclaimForm.get('time').hasError('pattern')">
        La hora tiene formato incorreco
      </mat-error>
    </mat-form-field>
    <div class="col-lg-4 m-auto">
      <mat-label style="font-size: 1.05rem;">Vía de respuesta preferida:</mat-label>
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
        formControlName="contact">
        <mat-radio-button class="example-radio-button" *ngFor="let item of contact" [value]="item">
          {{item.name}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</form>